import intlTelInput from 'intl-tel-input';
const utilsScriptUrl = require('../vendor/intl-tel-input/utils.js');

const DEFAULT_COUNTRY = "fr";
const PHONE_COUNTRY_INPUT_CLASS = "input-phone-intelligent--intl-patient";

function getIp(callback) {
 fetch('https://ipinfo.io/json?token=<votre token>', { headers: { 'Accept': 'application/json' }})
   .then((resp) => resp.json())
   .catch(() => {
     return {
       country: DEFAULT_COUNTRY,
     };
   })
   .then((resp) => callback(resp.country));
}

const isIntlPatientField = (phoneInputField) => {
  return phoneInputField.classList.contains(PHONE_COUNTRY_INPUT_CLASS);
};

const normaliseCountryFieldName = (phoneInputField) => {
  if (!phoneInputField.name) return null;

  return phoneInputField.name
    .replace("[telephone_user]", "[telephone_country]")
    .replace("[telephone]", "[telephone_country]");
};

const normaliseCountryFieldId = (phoneInputField) => {
  if (!phoneInputField.id) return null;

  return phoneInputField.id
    .replace("_telephone_user", "_telephone_country")
    .replace("_telephone", "_telephone_country");
};

const ensureTelephoneCountryField = (phoneInputField) => {
  if (!phoneInputField.form) return null;

  const countryFieldName = normaliseCountryFieldName(phoneInputField);
  if (!countryFieldName || countryFieldName === phoneInputField.name) return null;

  let countryField = Array.from(phoneInputField.form.querySelectorAll('input[type="hidden"]')).find((field) => {
    return field.name === countryFieldName;
  });

  if (!countryField) {
    countryField = document.createElement("input");
    countryField.type = "hidden";
    countryField.name = countryFieldName;

    const countryFieldId = normaliseCountryFieldId(phoneInputField);
    if (countryFieldId) {
      countryField.id = countryFieldId;
    }

    phoneInputField.form.appendChild(countryField);
  }

  return countryField;
};

const syncTelephoneCountryField = (phoneInputField, phoneInput) => {
  const countryField = ensureTelephoneCountryField(phoneInputField);
  const selectedCountry = phoneInput.getSelectedCountryData();
  const selectedCountryIso2 = selectedCountry && selectedCountry.iso2 ? selectedCountry.iso2 : DEFAULT_COUNTRY;

  if (countryField) {
    countryField.value = selectedCountryIso2;
  }

  phoneInputField.dataset.telephoneCountry = selectedCountryIso2;

  phoneInputField.dispatchEvent(new CustomEvent("telephone-country-changed", {
    bubbles: true,
    detail: {
      iso2: selectedCountryIso2,
    },
  }));

  return selectedCountryIso2;
};

const getFaceToFaceField = (form) => {
  return Array.from(form.querySelectorAll("select, input[type='hidden']")).find((field) => {
    return field.name && field.name.match(/\[face_to_face\]$/);
  });
};

const getIntlInfoContainer = (form) => {
  return form.querySelector(".alert-info-tel");
};

const setIntlInfoMessage = (form, message) => {
  const info = getIntlInfoContainer(form);
  if (!info) return;

  if (message) {
    info.style.display = "";
    info.innerHTML = message;
  } else {
    info.style.display = "none";
    info.innerHTML = "";
  }
};

const updateAppointmentModeForCountry = (phoneInputField, phoneInput) => {
  if (!phoneInputField.form) return;

  const selectedCountryIso2 = syncTelephoneCountryField(phoneInputField, phoneInput);
  const faceToFaceField = getFaceToFaceField(phoneInputField.form);
  if (!faceToFaceField) return;

  if (faceToFaceField.tagName === "SELECT") {
    Array.from(faceToFaceField.options).forEach((option) => {
      if (option.value === "Par téléphone") {
        option.disabled = selectedCountryIso2 !== DEFAULT_COUNTRY;
      }
    });
  }

  if (selectedCountryIso2 !== DEFAULT_COUNTRY) {
    if (faceToFaceField.value === "Par téléphone") {
      const fallbackOption = faceToFaceField.tagName === "SELECT" ?
        Array.from(faceToFaceField.options).find((option) => option.value && option.value !== "Par téléphone" && !option.disabled) :
        null;

      faceToFaceField.value = fallbackOption ? fallbackOption.value : "Par visioconférence";
      faceToFaceField.dispatchEvent(new Event("change", { bubbles: true }));
    }

    setIntlInfoMessage(phoneInputField.form, "Les rendez-vous téléphoniques sont réservés aux numéros de France métropolitaine.");
  } else {
    setIntlInfoMessage(phoneInputField.form, "");
  }
};

const initTelephoneField = (phoneInputField) => {
  if (!phoneInputField) return null;
  if (phoneInputField._tomoIntlTelInput) return phoneInputField._tomoIntlTelInput;

  const intlTelOptions = {
   initialCountry: DEFAULT_COUNTRY,
   geoIpLookup: getIp,
   utilsScript: utilsScriptUrl,
  };

  if (!isIntlPatientField(phoneInputField)) {
    intlTelOptions.onlyCountries = [DEFAULT_COUNTRY];
  }

  const phoneInput = intlTelInput(phoneInputField, intlTelOptions);
  phoneInputField._tomoIntlTelInput = phoneInput;

  syncTelephoneCountryField(phoneInputField, phoneInput);

  if (isIntlPatientField(phoneInputField)) {
    phoneInputField.addEventListener("countrychange", () => {
      updateAppointmentModeForCountry(phoneInputField, phoneInput);
    });

    updateAppointmentModeForCountry(phoneInputField, phoneInput);
  }

  return phoneInput;
};

const initIntelTelephone = () => {
  if (document.querySelector(".form-phone-intelligent")) {
    const formPhoneIntelligents = document.querySelectorAll(".form-phone-intelligent");
    for ( var i = 0; i < formPhoneIntelligents.length; i++ ) (function(i){

      let phoneInputField = formPhoneIntelligents[i].querySelector(".input-phone-intelligent");
      initTelephoneField(phoneInputField);

    })(i);

  }


};


export { DEFAULT_COUNTRY, PHONE_COUNTRY_INPUT_CLASS, initIntelTelephone, initTelephoneField, isIntlPatientField, syncTelephoneCountryField };
